import { ListingFacades } from '@components/listing-facades/models';
import { Block } from '@shared/models';

export function getCategoryNameFromUrl(): string {
  const FALLBACK_VALUE = '';

  // Protects against server-side rendering environments where `window` is not defined.
  if (typeof window === 'undefined') {
    return FALLBACK_VALUE;
  }

  // Splits the path into segments and filters out empty strings (from leading/trailing slashes).
  const pathSegments = window.location.pathname.split('/').filter(Boolean);

  // Gets the last path segment. `pop` returns `undefined` if the array is empty.
  const lastSegment = pathSegments.pop();

  // If no segment is found, returns the default value.
  if (!lastSegment) {
    return FALLBACK_VALUE;
  }

  // Capitalizes the first letter and returns the modified string.
  return lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1);
}

export const listingFacadesMock: Block<ListingFacades> = {
  type: 'listing-facades',
  data: {
    breathingText: 'Nos meubles sont fabriqués en France, garantis 10 ans et livrés chez vous [[déjà montés]]',
    categoryName: getCategoryNameFromUrl() || 'Mat',
  },
};
